<template>
        <div class="container default-shadow">
            <div id="device">
                {{device_name}} <span v-if="device_name == this_id">(this device)</span>
            </div>
            <div id="screen-selection">
                <div v-for="slide in slides">
                    <v-icon :icon="slide.icon" size="4.5rem" color="#3d5afe" @click="showSlide(slide.index)"
                    class="sci-icon" :class="{'sci-icon-active': currently_showing == slide.title}"/>
                </div>
            </div>
        </div>
</template>

<script setup lang="js">
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const slides = computed(() => store.state.presentation_slides);
const this_id = computed(() => store.state.presentation_device_id);

/**
 * @emit show-slide - Sends an emit that eventually tells the device [device_name] to show a specific slide.
 */
const emit = defineEmits(['show-slide'])

/**
 * @prop device_name - Name of the device this component controls.
 * @prop currently_showing - The slide that device is currently showing.
 */
const props = defineProps({
    device_name: String,
    currently_showing: String,
})

/**
 * Checks whether the according device is already showing the slide it should show.
 * If it doesn't, then the according emit is propagated up to the websocket and sent to the device.
 * @param {String} slide_index - Index of the slide, e.g. "0"
 */
const showSlide = (slide_index) => {
    if (props.currently_showing == slides.value[slide_index].title) return;
    emit('show-slide', slide_index);
}
</script>

<style scoped>

.container {
    font-size: 1.125rem;
    width: 100%;
    margin: auto;
    display: grid;
    grid-template-columns: 2fr 3fr;
    align-items: center;
    justify-items: center;
    grid-auto-flow: column;
    background-color: #f6f6f6;
    min-height: 5rem;
    padding-bottom: 4px;
    margin-top: 1%;
    margin-bottom: 1%;
}

#device {
    margin-left: 1ch;
}

#screen-selection {
    width: 100%;
    display: grid;
    align-items: center;
    height: 100%;
    grid-auto-flow: column;
}

.beamer-arrow {
    margin-top: 2%;
}

.selection-icons {
    display: grid;
    grid-auto-flow: column;
    column-gap: 2ch;
    margin-right: 16px;
    grid-template-columns: 8fr;
    height: 100%;
}

.selection-icons > .Icon {
    scale: 1.3 1.3;
}

.screen-icons {
    display: grid;
    align-items: center;
    justify-items: center;
    grid-template-rows: 1fr;
    grid-auto-flow: column;
    column-gap: 1ch;
}

.sci {
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
}

.sci::after {
    font-size: 0.7rem;
    position: absolute;
    top: 87%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    content: attr(icon_desc);
    width: 100%;
    white-space: nowrap;
}

.sci-icon {
    cursor: pointer;
}

.sci-icon-active {
    cursor: default;
    color: #31d447 !important;
}

@media (max-width: 1500px) {

.container {
    font-size: 1rem;
}

.sci::after {
    font-size: 0.6rem;
    top: 88%;
}

.sci-icon {
    scale: 1.1 1.1;
}

}

@media (max-width: 1200px) {

.container {
    font-size: .875rem;
    min-height: 3.5rem;
}

.sci::after {
    font-size: 0.55rem;
}

}

@media (max-width: 900px) {

.sci::after {
    white-space: normal;
    font-size: 0.45rem;
}

}

@media (max-width: 750px) {

.container {
    font-size: 0.75rem;
    min-height: 3rem;
}

.sci-icon {
    scale: 1.9 1.9;
}

.sci::after {
    content: '';
    display: none;
}

}

</style>